import { image } from "./image";
import { invoice } from "./invoice";
import * as organization from "./organization";
import { paymentCards } from "./payment-card";
import { paymentPlan } from "./payment-plan";
import { paymentSystem } from "./payment-system";
import * as permission from "./permission";
import { promocode } from "./promocode";
import { subscription } from "./subscription";

//

export const clientApi = {
  organization,
  subscription,
  image,
  paymentPlan,
  invoice,
  paymentCards,
  paymentSystem,
  promocode,
  permission,
};
